import React from "react"
import { useSelector } from "react-redux"
import { RootState } from "@app/types"

import { CartPickerLazy } from "@ng-mw/shared-react-components/cart"

import { TrumfIdLoginDrawerWrapper } from "@ng-mw/shared-react-components/trumf-id-login-drawer"
import AgreementDeactivationPopup from "@modules/user/pages/AgreementDeactivationPopup"
import AppOnboardingPoster from "@modules/onboarding/pages/AppOnboardingPoster"
import AppRatingPopup from "@modules/onboarding/pages/AppRatingPopup"
import AppUpgradePopup from "@modules/onboarding/pages/AppUpgradePopup"
import BarcodePopup from "@modules/barcode/pages/BarcodePopup"
import CategoryFilterPopup from "@modules/products/pages/CategoryFilterPopup"
import CheckoutPaymentPopup from "@modules/checkout/pages/CheckoutPaymentPopup"
import ClimateComparisonPopup from "@modules/insight/climate/pages/ClimateComparisonPopup"
import ClimateInformationPopup from "@modules/insight/climate/pages/ClimateInformationPopup"
import ClimateNumbersPopup from "@modules/insight/climate/pages/ClimateNumbersPopup"
import ClimateProductGroupsInfoPopup from "@modules/insight/climate/pages/ClimateProductGroupsInfoPopup"
import CouponInfoPopup from "@modules/savings/pages/CouponInfoPopup"
import DietEnergyPopup from "@modules/insight/diet/pages/DietEnergyPopup"
import DietPropertyPopup from "@modules/insight/diet/pages/DietPropertyPopup"
import FeedbackPopup from "@modules/shared/pages/FeedbackPopup"
import QuestbackFeedbackPopup from "@modules/shared/pages/QuestbackFeedbackPopup"
import HandoverPickerPopup from "@modules/checkout/pages/HandoverPickerPopup"
import InsightAboutPopup from "@modules/insight/common/pages/InsightAboutPopup"
import InsightGroupPopup from "@modules/insight/common/pages/InsightGroupPopup"
import InsightKeyFiguresPopup from "@modules/insight/diet/pages/InsightKeyFiguresPopup"
import LoginPopup from "@modules/auth/pages/LoginPopup"
import LogOutPopup from "@modules/auth/pages/LogOutPopup"
import PurchaseComplaintPopup from "@modules/orders/pages/PurchaseComplaintPopup"
import PurchaseDetailsPopup from "@modules/orders/pages/PurchaseDetailsPopup"
import PushConsentsPopup from "@modules/user/pages/PushConsentsPopup"
import ProductPopup from "@modules/products/pages/ProductPopup"
import RegistrationPopup from "@modules/onboarding/pages/RegistrationPopup"
import RecipeRatingPopup from "@modules/recipes/pages/RecipeRatingPopup"
import DinnerSuggestionsPopup from "@modules/recipes/pages/DinnerSuggestionsPopup"
import DinnerSuggestionsPreferencesDrawer from "@modules/recipes/DinnerSuggestionsPreferencesDrawer"
import ShoppingListChangeNamePopup from "@modules/shopping-lists/pages/ShoppingListChangeNamePopup"
import ShoppingListCreatePopup from "@modules/shopping-lists/pages/ShoppingListCreatePopup"
import ShoppingListRemovePopup from "@modules/shopping-lists/pages/ShoppingListRemovePopup"
import UserQrPopup from "@modules/user/pages/UserQrPopup"
import RecipePopup from "@modules/recipes/pages/RecipePopup"
import ForcedUpgradePopup from "@modules/onboarding/pages/ForcedUpgradePopup"
import OsUpgradePopup from "@modules/onboarding/pages/OsUpgradePopup"
import FirstTrumfIdModal from "@modules/onboarding/pages/FirstTrumfIdModal"
import NewsPopup from "@modules/onboarding/pages/NewsPopup"
import ActivateLoyaltyClubPopup from "@modules/loyalty-club/pages/ActivateLoyaltyClubPopup"
import WelcomePopup from "@modules/loyalty-club/pages/WelcomePopup"
import GamePage from "@modules/seasonal/pages/GamePage"
import PersonalCampaignsPopup from "@modules/user/pages/PersonalCampaignsPopup"
import PersonalCampaignPopup from "@modules/user/pages/PersonalCampaignPopup"
import TmpCampaignPopup from "@modules/home/pages/TmpCampaignPopup"
import TopBannerPopup from "@modules/home/TopBannerPopup"
import FeaturedCampaignPopup from "@modules/savings/pages/FeaturedCampaignPopup"
import CouponPopups from "@modules/loyalty-club/CouponPopups"
import { isDebugMode } from "@app/helpers"
import { FiChevronLeft } from "@ng-mw/reol/icon-components/FiChevronLeft"
import { NativeEvent, NativeEventBridge } from "@ng-mw/shared-react-components"
import CouponPopup from "@modules/savings/pages/CouponPopup"
import AppLink from "@modules/shared/AppLink"
import PathNames from "@app/const/PathNames"
import plusIcon from "@ng-mw/reol/icons/plus"
import Icon from "@ng-mw/reol/components/Icon"

function testHistoryBack() {
    NativeEventBridge.broadcastNative(NativeEvent.AndroidNavigateBack)
}

interface PopupProps {
    showNativeDebugLink: boolean
}

const Popups = ({ showNativeDebugLink }: PopupProps) => {
    const safeArea = useSelector((state: RootState) => state.native.safeArea)

    const isDebugModeActive = isDebugMode()

    return (
        <div id="popups-area">
            <AppRatingPopup />
            <BarcodePopup />
            <FirstTrumfIdModal />
            <PurchaseDetailsPopup />
            <PurchaseComplaintPopup />
            <CouponInfoPopup />
            <CouponPopup />
            <CategoryFilterPopup />
            <InsightAboutPopup />
            <InsightKeyFiguresPopup />
            <InsightGroupPopup />
            <DietEnergyPopup />
            <DietPropertyPopup />
            <GamePage />
            <ClimateComparisonPopup />
            <ClimateInformationPopup />
            <ClimateNumbersPopup />
            <ClimateProductGroupsInfoPopup />
            <AgreementDeactivationPopup />
            <LoginPopup />
            <PersonalCampaignsPopup />
            <PersonalCampaignPopup />
            <TopBannerPopup />
            <FeaturedCampaignPopup />
            {
                // The following popups needs to be later and in a specific order:
            }
            <FeedbackPopup />
            <QuestbackFeedbackPopup />
            <CheckoutPaymentPopup />
            <ProductPopup /> {/* Product should be fairly high */}
            <CouponPopups />
            <HandoverPickerPopup />
            <CartPickerLazy /> {/* Merge or choose cart when logging in */}
            <RegistrationPopup />
            <AppUpgradePopup />
            <NewsPopup />
            <TmpCampaignPopup />
            <ShoppingListRemovePopup />
            <ShoppingListChangeNamePopup />
            <ShoppingListCreatePopup />
            <RecipePopup />
            <RecipeRatingPopup />
            <DinnerSuggestionsPopup />
            <DinnerSuggestionsPreferencesDrawer />
            <ActivateLoyaltyClubPopup />
            <ForcedUpgradePopup />
            <OsUpgradePopup />
            <LogOutPopup />
            {
                // The following popups needs to be later and in a specific order:
            }
            <WelcomePopup />
            <PushConsentsPopup />
            <AppOnboardingPoster />
            <UserQrPopup />
            <TrumfIdLoginDrawerWrapper safeAreaBottom={safeArea.bottom} />
            {isDebugModeActive ? (
                <button
                    className={
                        showNativeDebugLink
                            ? "native-debug-control native-debug-control--back"
                            : "app-navigation__debug-back"
                    }
                    onClick={testHistoryBack}
                >
                    <FiChevronLeft />
                </button>
            ) : null}
            {isDebugModeActive && showNativeDebugLink ? (
                <AppLink
                    className="native-debug-control native-debug-control--link"
                    instant
                    to={PathNames.Debug}
                >
                    <Icon icon={plusIcon} />
                    <span className="ws-visually-hidden">Debug</span>
                </AppLink>
            ) : null}
        </div>
    )
}

export default Popups
